/* global wp, jQuery */

( function( $ ) {
   
	$(".closer").click(function(){
        $(".modal").removeClass("active");
        $("body").removeClass("active");
    });  

    $( ".m-open" ).click(function(ev) {
        ev.stopImmediatePropagation(); // stop firing twice
        $(".modal").removeClass("active");
        var page = $(this).attr('rel');
        $("#"+page).addClass("active");
        $("body").addClass("active");
    });
}( jQuery ) );
 